// ─────────────────────────────────────────────────────────────────────────────
// Versionierung – Single Source of Truth für die App-Version.
// Diese Datei wird beim nächsten Release einfach aktualisiert.
// ─────────────────────────────────────────────────────────────────────────────

export const APP_VERSION = '1.13.0';

// Optionales Label, das vor der Versionsnummer angezeigt wird.
// Beispiele: 'EARLY ACCESS', 'BETA', 'STABLE', '' (kein Label)
export const VERSION_LABEL = 'EARLY ACCESS';

// Wird im Footer / in der Sidebar angezeigt
export const VERSION_DISPLAY = VERSION_LABEL
  ? `${VERSION_LABEL} – v${APP_VERSION}`
  : `v${APP_VERSION}`;
